import { create } from 'zustand'

import { State, Store } from './types'

const initialState: State = {
    funcionariosImportar: undefined,
    erro: null,
    linhaInicial: 1,
    isLoading: false,
    Cidade: undefined,
}

export const useImportacaoStore = create<Store>((set, get) => ({
    state: initialState,
    actions: {
        setImports: value => {
            if (typeof value === 'function') {
                set({
                    state: {
                        ...get().state,
                        funcionariosImportar: value(
                            get().state.funcionariosImportar,
                        ),
                    },
                })
            } else {
                set({
                    state: {
                        ...get().state,
                        funcionariosImportar: value,
                    },
                })
            }
        },
        setErro: value => {
            if (typeof value === 'function') {
                set({
                    state: {
                        ...get().state,
                        erro: value(get().state.erro),
                    },
                })
            } else {
                set({
                    state: {
                        ...get().state,
                        erro: value,
                    },
                })
            }
        },
        setLinhaInicial: value => {
            set({
                state: {
                    ...get().state,
                    linhaInicial: value,
                },
            })
        },
        setIsLoading: value => {
            set({
                state: {
                    ...get().state,
                    isLoading: value,
                },
            })
        },
        setCidade: value => {
            set({
                state: {
                    ...get().state,
                    Cidade: value,
                },
            })
        },
        reset: () => {
            set({
                state: initialState,
            })
        },
    },
}))
